module.exports = __webpack_public_path__ + "img/instagram.82526960.svg";